"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Navbar_1 = __importDefault(require("../components/Navbar"));
var Order_1 = __importDefault(require("../components/Order"));
var AxiosClient_1 = require("../utils/AxiosClient");
var functions_1 = require("../interfaces/functions");
var react_router_1 = require("react-router");
var react_toastify_1 = require("react-toastify");
var system_1 = require("@mui/system");
var material_1 = require("@mui/material");
require("../assets/styles/order.css");
function Orders() {
    var _a = (0, react_1.useState)([]), orders = _a[0], setorders = _a[1];
    var token = (0, functions_1.getCookie)("token");
    var navigate = (0, react_router_1.useNavigate)();
    (0, react_1.useEffect)(function () {
        if (token) {
            AxiosClient_1.AxiosClient.get("/orders/userorders", {
                headers: {
                    Authorization: "Bearer ".concat(token),
                },
            })
                .then(function (response) {
                if (response.data.statusCode == 200) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    setorders(response.data.orders);
                }
            })
                .catch(function (error) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                react_toastify_1.toast.error(error.response.data.message);
            });
        }
        else {
            navigate("/login");
        }
    }, []);
    return (react_1.default.createElement("div", { className: "backOrder" },
        react_1.default.createElement(Navbar_1.default, { iconNumber: 5 }),
        react_1.default.createElement("div", { className: "secondoption" },
            react_1.default.createElement(material_1.Typography, { component: "div", variant: "h3", color: "primary", sx: { fontWeight: 600, textAlign: "center" } }, "Orders")),
        react_1.default.createElement(system_1.Box, { sx: {
                diplay: "flex",
                flexDirection: "column",
                width: "90%",
                margin: "10px auto",
                padding: "10px",
                boxShadow: "0 7px 10px 1px rgba(0, 0, 0, 0.3)",
                background: "#ffff",
            } }, orders.map(function (order) {
            return (react_1.default.createElement(Order_1.default, { key: order.Orderid, Orderid: order.Orderid, expectedDeliveryDate: order.expectedDeliveryDate, amountPaid: order.amountPaid, userId: order.userId, paymentid: order.paymentid, status: order.status, createdAt: order.createdAt, updatedAt: order.updatedAt, orderProducts: order.orderProducts }));
        })),
        react_1.default.createElement(system_1.Box, { className: "bottomdiv" })));
}
exports.default = Orders;
